import { render } from "./Lesson.vue?vue&type=template&id=ae9d0b7e&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"

import "./Lesson.vue?vue&type=style&index=0&id=ae9d0b7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae9d0b7e"]])

export default __exports__